import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import { getProductIdByEan, getProductStockByEan, createAndOrAddToCart, createAndAddToCart, updateCartEntry, updateCartDeliveryAddress, createOrder, cancelOrder, submitOrder, createCustomer, login, logout, forgotPassword, addAddress, getPaymentMode, getPaymentModeByCartId } from '../actions/Bahag.action';

class GermanyCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingQuantity: {},
            removingRow: {},
            campaignTrigger: false,
            enableCampaignTrigger: true,
            currency: "",
        };
    }

    onQuantityChange(rowSystemId, quantity) {
        this.setState(previousState => ({
            ...previousState,
            editingQuantity: {
                ...previousState.editingQuantity,
                [rowSystemId]: quantity,
            }
        }));
        this.props.updateOrderRowQuantity(rowSystemId, quantity);
    }

    onDeleteRequest(rowSystemId, showDeleteButton) {
        this.setState(previousState => ({
            ...previousState,
            removingRow: {
                ...previousState.removingRow,
                [rowSystemId]: showDeleteButton,
            }
        }));
    }

    handleUpdateClick(rowSystemId, currentQuantity, originalQuantity) {
        if (currentQuantity === originalQuantity) {
            return;
        }
        this.props.updateOrderRowQuantity(rowSystemId, currentQuantity);
    }
    onSubmitCampaignCode() {
        if (this.props.hasDiscount) {
            this.props.onRemoveCampaignCode();
            setTimeout(() => {
                var campaignCodeButton = document.getElementById("campaign-code-button");
                if (campaignCodeButton) {
                    campaignCodeButton.innerHTML = translate('checkout.usecampaigncode');
                }
            }, 1000);
        } else {
            this.props.onSubmitCampaignCode();
            this.setState({ enableCampaignTrigger: true })
        }
    }
    componentDidUpdate() {
        if (this.props.hasDiscount && this.state.enableCampaignTrigger) {
            var campaignCodeButton = document.getElementById("campaign-code-button");
            if (campaignCodeButton) {
                campaignCodeButton.innerHTML = "✓";
                campaignCodeButton.classList.add("campaignCodeButtonDone");
                setTimeout(() => {
                    campaignCodeButton.innerHTML = translate('checkout.campaign-remove');
                    campaignCodeButton.classList.remove("campaignCodeButtonDone");
                }, 3000);
            }
            this.setState({ enableCampaignTrigger: false })
        }
    }

    checkIfAnyProductNotAvailable() {
        const isAnyProductNotAvailable = this.props.orderRowsWithStock.some(item => !item.available);
        const missingeProductErrorMessage = document.getElementById("missing-products-cart");
        if (missingeProductErrorMessage) {
            if (isAnyProductNotAvailable) {
                missingeProductErrorMessage.removeAttribute("hidden");
            } else {
                missingeProductErrorMessage.setAttribute("hidden", true);
            }
        }
    }

    componentDidMount() {
        const orderTotal = this.orderTotal();
        this.setState({ orderTotal });
    }

    render() {
        const editingQuantity = this.state.editingQuantity;
        const removingRow = this.state.removingRow;
        const hasCampaignError = this.props.errors && this.props.errors['campaignCode'] && this.props.errors['campaignCode'][0] !== undefined;


        return <Fragment><div className="checkout__cartContainer germany-cart"><div>
            <h3 className="checkout__section-title">{translate('checkout.cart.title')} ({this.props.quantity})</h3>
            <div className="checkout__productList">

                {this.props.orderRows &&
                    this.props.orderRows.map(order => {
                        const stockData = this.props.orderRowsWithStock.find(item => item.itemEAN === order.itemEAN);
                        const isNotAvailable = stockData && stockData.available === false;
                        const selectedReseller = this.props.selectedReseller;

                        if (selectedReseller !== "") {
                            this.checkIfAnyProductNotAvailable();
                        }
                        return (
                            <div className={`checkout-cart__row ${isNotAvailable && selectedReseller !== "" ? 'orderRows-not-available' : ''}`} key={order.rowSystemId}>
                                <div className="checkout-cart__image" >
                                    <img src={order.image} alt={order.name} />
                                </div>
                                <div className='checkout-cart__mid'>
                                    <span className="checkout-cart__brand-name" >{order.brand}</span>
                                    <a className='checkout-cart__mid--data' href={order.url}>{order.name}</a>
                                    <div className='checkout-cart__mid--data'>
                                        {order.campaignPrice ?
                                            <Fragment>
                                                <div className='checkout-cart__campaign-price'>{order.campaignPrice}</div>
                                                <div className='checkout-cart__original-price'> ({order.price})</div>
                                            </Fragment>
                                            : order.totalPrice
                                        }
                                    </div>


                                    <div>
                                        {!order.isFreeGift &&
                                            <a className="" onClick={() => this.handleUpdateClick(order.rowSystemId, editingQuantity[order.rowSystemId] || order.quantity, order.quantity)}></a>
                                        }
                                    </div>
                                </div>
                                <div className='checkout-cart__right'>
                                    {!order.isFreeGift && !removingRow[order.rowSystemId] && <a className="checkout-cart__delete"
                                        onClick={() => this.props.removeOrderRow(order.rowSystemId).then(() => this.checkIfAnyProductNotAvailable())} title={translate('general.remove')}>✖</a>
                                    }

                                    {order.isFreeGift ? <div>{order.quantity}</div> :
                                        <div className='checkout-cart__changeQuantity'>
                                            <button onClick={() => this.onQuantityChange(order.rowSystemId, order.quantity - 1)}>-</button>
                                            <div>{editingQuantity[order.rowSystemId] || order.quantity}</div>
                                            <button onClick={() => this.onQuantityChange(order.rowSystemId, order.quantity + 1)}>+</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })}
            </div>
            <div className="checkput-prices">
                {this.props.showCampaignField &&
                    <div className="checkout__campaign">
                        <div className="checkout__campaign--trigger" onClick={() => this.setState((prev) => ({ campaignTrigger: !prev.campaignTrigger }))}>
                            <label className="campaign-code" htmlFor="campaign-code">{translate('checkout.campaigncode')}</label>
                            <div className={`arrow-down ${!this.state.campaignTrigger ? "" : "rotate-180"}`}></div>
                        </div>
                        <div id="campaign-code-input" className={`campaign-code__parent ${!this.state.campaignTrigger ? "displayNone" : ""}`}>
                            <div className="campaign-code__container">
                                <div className="campaign-code__container--inputContainer">
                                    <input
                                        className={`campaign-code__container--input 
                                                  ${hasCampaignError && !this.props.hasDiscount && "campaign-code__container--inputError"} 
                                                  ${this.props.hasDiscount ? "campaign-code__container--inputDisable" : ""}
                                        `}
                                        id="campaign-code"
                                        placeholder={translate('checkout.campaigncode')}
                                        onChange={(event) => this.props.onCampaignCodeChange(event.target.value)} />
                                </div>
                                <div className='campaig-code-button-wrapper'>
                                    <button id='campaign-code-button' className="checkout-info__campaign-button" onClick={() => this.onSubmitCampaignCode()}>
                                        {translate('checkout.usecampaigncode')}
                                    </button>
                                </div>
                            </div>
                            {hasCampaignError && !this.props.hasDiscount &&
                                <span className="campaign-code__error" data-error-for="campaign-code">{this.props.errors['campaignCode'][0]}</span>
                            }
                        </div>
                    </div>
                }

                <div className="checkout-prices__details">
                    <div>
                        <p>{translate('checkout-cart-subtotal')}</p>
                        <p>{this.orderTotalWithoutDelivery()} {this.state.currency}*</p>
                    </div>
                    <div>
                        <p>{translate('checkout-cart-shipping')}</p>
                        <p>
                            {this.calculateDeliveryCost(this.props.selectedReseller)}
                            {this.props.selectedReseller && ` ${this.state.currency}`}
                        </p>
                    </div>
                    {this.props.hasDiscount &&
                        <div>
                            <p>{translate('checkout.order.discount')}</p>
                            <p>{this.props.discount}</p>
                        </div>
                    }
                </div>
                <div className="checkout-prices__total">
                    <h6>{translate('checkout.cart.total')}</h6>
                    <p id="checkout-total-price">{this.orderTotal()} {this.state.currency}</p>
                </div>
                <p className="bahag-prices-description">{translate("checkout.bahag.prices.description.text")}</p>
            </div>
            {translate('product.recommended-price') !== "product.recommended-price" ?
                <div className="checkout-prices__recommendedPriceText">
                    <p>* {translate('product.recommended-price')}</p>
                </div>
                : ""
            }
            <div className='checkout__cartArrow'></div>
        </div>
        </div>
        </Fragment>

    }

    orderTotalWithoutDelivery() {
        const { orderRows, orderRowsWithStock } = this.props;
        let totalprice = 0;
        for (const item of orderRows) {
            const matchingRow = orderRowsWithStock.find(row => row.rowSystemId === item.rowSystemId && row.available);
            if (matchingRow) {
                if (item.totalPrice) {
                    totalprice += this.extractNumericValue(item.totalPrice);
                }
            }
        }
        return totalprice;
    }

    orderTotal() {
        let orderRowPrice = this.orderTotalWithoutDelivery();
        let deliveryCost = 0;
        if (orderRowPrice < 30 && orderRowPrice > 0) {
            deliveryCost = 4.90;
            orderRowPrice += deliveryCost;
        }
        return orderRowPrice;
    }

    calculateDeliveryCost(selectedReseller) {
        let orderRowPrice = this.orderTotalWithoutDelivery();
        let deliveryCost = 0;
        if (selectedReseller === "bahag") {
            if (orderRowPrice < 30 && orderRowPrice > 0) {
                return deliveryCost = 4.90;
            } else {
                return deliveryCost;
            }
        } else {
            return translate('checkout.cart.shipping.text')
        }
    }

    extractNumericValue(value) {
        const matches = value.match(/([^\d.,]+)([\d.,]+)/);
        const numericValue = parseFloat(value.replace(/[^\d.,]/g, '').replace(',', '.'));
        const textBeforeNumeric = matches[1].trim();
        if (this.state.currency === "") {
            this.setState({ currency: textBeforeNumeric })
        }

        if (!isNaN(numericValue)) {
            return numericValue;
        }
    }
}

const mapStateToProps = state => {
    return {
        orderRowsWithStock: state.bahag.orderRowsWithStock,
        selectedReseller: state.bahag.selectedReseller,
    }
}

const mapDispatchToProps = {
    getProductIdByEan,
    getProductStockByEan,
    createAndOrAddToCart,
    createAndAddToCart,
    updateCartEntry,
    updateCartDeliveryAddress,
    createOrder,
    cancelOrder,
    submitOrder,
    createCustomer,
    login,
    logout,
    forgotPassword,
    addAddress,
    getPaymentMode,
    getPaymentModeByCartId,
};

export default connect(mapStateToProps, mapDispatchToProps)(GermanyCart);